import constants from "@/_consts";

const defaultMethod = "GET";
const apiVersion = "v1";
const apiVersion2 = "v2";

/**
 * Build options
 */
export function buildOptions(method = defaultMethod, body, customHeaders) {
  const token = sessionStorage.getItem(constants.LOCAL_STORE.accessToken);
  const refreshToken = sessionStorage.getItem(
    constants.LOCAL_STORE.refreshToken
  );
  return {
    method,
    headers: {
      ...{
        "Content-Type": "application/json",
        Authorization: token,
        "X-Auth-Token": refreshToken
      },
      ...customHeaders
    },
    data: body,
    responseType: body && body.responseType ? body.responseType : "json",
    params: body && body.params ? body.params : null
  };
}

/**
 * Build api server
 */
export function buildApiServer() {
  return process.env.CLIENTCENTER_API_SERVER_HOST;
}

/**
 * Build endpoints
 */
export function getEndPoints() {
  return {
    employers: {
      getEmployers: buildApiServer() + "/api/" + apiVersion + "/employers",
      getEmployersCompact:
        buildApiServer() + "/api/" + apiVersion + "/employers/compact",
      add: buildApiServer() + "/api/" + apiVersion + "/employers",
      edit: buildApiServer() + "/api/" + apiVersion + "/employers/:id",
      deleteEmployer:
        buildApiServer() + "/api/" + apiVersion + "/employers/:id",
      detail: buildApiServer() + "/api/" + apiVersion + "/employers/:id",
      getProvider: buildApiServer() + "/api/" + apiVersion + "/providers",
      addClientSftp:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/employers/:id/sftps/:clientSftpId",
      getClientSftp:
        buildApiServer() + "/api/" + apiVersion + "/employers/sftps/:id",
      getSftp: buildApiServer() + "/api/" + apiVersion + "/employers/:id/sftps",
      getFileSources: buildApiServer() + "/api/" + apiVersion + "/filesources",
      getFileSource:
        buildApiServer() + "/api/" + apiVersion + "/filesources/:id",
      addFileSource: buildApiServer() + "/api/" + apiVersion + "/filesources",
      deleteFileSource:
        buildApiServer() + "/api/" + apiVersion + "/filesources/:id",
      getPGPCertificates:
        buildApiServer() + "/api/" + apiVersion + "/certificates",
      getPGPCertificatesByEmployer:
        buildApiServer() + "/api/" + apiVersion + "/employers/:id/certificates",
      deleteCertificate:
        buildApiServer() + "/api/" + apiVersion + "/certificates/:id",
      getPGPCertificate:
        buildApiServer() + "/api/" + apiVersion + "/certificates/:id",
      addPGPCertificate:
        buildApiServer() + "/api/" + apiVersion + "/certificates",
      getExistCustomerIdentify:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-settings-by-client/:clientId",
      generateCustomerIdentify:
        buildApiServer() + "/api/" + apiVersion + "/client-settings",
      regCreditCardForAccount:
        buildApiServer() + "/api/" + apiVersion + "/tango-card/registerCredit",
      addFund:
        buildApiServer() + "/api/" + apiVersion + "/tango-card/depositCredit",
      updateThreshold:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-settings/update-threshold",
      getListCreditCards:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-settings/:customerIdentifier/creditcard/:accountIdentifier",
      syncMultiSubgroup:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/employers/:employer_id/sync-subgroups",
      addIdp:
        buildApiServer() + "/api/" + apiVersion + "/employers/:employer_id/idp",
      updateIdp:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/employers/:employer_id/idp/:provider_name",
      getIdp:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/employers/:employer_id/idp/:provider_name",
      enableSSO:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/employers/:employer_id/idp-status/:value"
    },
    employees: {
      getEmployees: buildApiServer() + "/api/" + apiVersion + "/employees?include=reference",
      getEmployee: buildApiServer() + "/api/" + apiVersion + "/employees/:id?include=employer,profile.mfa,reference&all=1",
      getEmployeeFileHistory: buildApiServer() + "/api/" + apiVersion + "/employees/:id/transaction",
      addTestEmployee: buildApiServer() + "/api/" + apiVersion + "/employees-test",
      editTestEmployee: buildApiServer() + "/api/" + apiVersion + "/employees/:id?nomap=1",
      terminateEmployee: buildApiServer() + "/api/" + apiVersion + "/employees/:id/terminate",
      forceDeleteEmployee: buildApiServer() + "/api/" + apiVersion + "/employees/:id/force-delete",
      getEmployeeAccountHistory: buildApiServer() + "/api/" + apiVersion + "/employees/:id/history",
      revertEmployeeChange: buildApiServer() + "/api/" + apiVersion + "/employees/:id/revert/:history_id",
      revertEmployeeProfileChange: buildApiServer() + "/api/" + apiVersion + "/employees/:id/profile/revert/:history_id"
    },
    users: {
      login: buildApiServer() + "/api/" + apiVersion + "/login",
      forgotPassword:
        buildApiServer() + "/api/" + apiVersion + "/auth/forgot-password",
      confirmForgotPassword:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/auth/confirm-forgot-password",
      changePassword:
        buildApiServer() + "/api/" + apiVersion + "/auth/change-password",
      updateInfo:
        buildApiServer() + "/api/" + apiVersion + "/users/update-info",
      add: buildApiServer() + "/api/" + apiVersion + "/users/new",
      edit: buildApiServer() + "/api/" + apiVersion + "/users/:id/update",
      getUsers: buildApiServer() + "/api/" + apiVersion + "/users",
      detail: buildApiServer() + "/api/" + apiVersion + "/users/:id",
      getUserTangoBalance: buildApiServer() + "/api/" + apiVersion2 + "/client-tango-accounts/verification",
      block: buildApiServer() + "/api/" + apiVersion + "/users/:id/block",
      reinvite:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/users/:user_id/invitation-re-generate",
      invitation_token:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/users/:invitation_token/verify",
      cognitoConfirmPassword:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/users/:user_id/cognito-confirm-password",
      confirmChallenge:
        buildApiServer() + "/api/" + apiVersion + "/confirm-challenge",
      setupMFAMethod:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/cognito-users/cognito-mfa-preference-challenge",
      getActivitiesLogEntities:
        buildApiServer() + "/api/" + apiVersion + "/activity-logs/entities",
      getActivitiesLogs:
        buildApiServer() + "/api/" + apiVersion + "/activity-logs"
    },
    report_categories: {
      getAll:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/report_categories/get_all/:employer_id",
      getCategories:
        buildApiServer() + "/api/" + apiVersion + "/report_categories",
      add: buildApiServer() + "/api/" + apiVersion + "/report_categories",
      edit: buildApiServer() + "/api/" + apiVersion + "/report_categories/:id",
      deleteEmployer:
        buildApiServer() + "/api/" + apiVersion + "/report_categories/:id",
      detail: buildApiServer() + "/api/" + apiVersion + "/report_categories/:id"
    },
    query_results: {
      getList: buildApiServer() + "/api/" + apiVersion + "/query-results",
      add: buildApiServer() + "/api/" + apiVersion + "/query-results",
      edit: buildApiServer() + "/api/" + apiVersion + "/query-results/:id",
      deleteEmployer:
        buildApiServer() + "/api/" + apiVersion + "/query-results/:id",
      detail: buildApiServer() + "/api/" + apiVersion + "/query-results/:id",
      getChartData:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/query-results/:id/chart-data",
      getRiskFactorsData:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/query-results/get-risk-factors/:employer_name/:demo",
      getModalityByType:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/query-results/modality-by-type/:employer_name/:demo",
      getChartDummyData:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/query-results/:id/chart_dummy_data",
      lastTimeUpdated:
        buildApiServer() + "/api/" + apiVersion + "/etl/last-time-updated"
    },
    files_processing: {
      getList: buildApiServer() + "/api/" + apiVersion + "/file_process",
      getTransaction:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/file_process/:transaction_id",
      uploadUrl: buildApiServer() + "/api/" + apiVersion + "/file_upload",
      getFileUploadError:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/data-transaction/:transaction_id/errors",
      downloadFileUpload:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/data-transaction/employers/:employer_id/files/:file_id/download",
      downloadErrorFileReview:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/data-transaction/download_to_review_affected_rows/:transaction_id/:code",
      uploadTestedFile:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/file_upload/upload-file-after-complete-testing/:transaction_id",
      downloadTemplateFile:
        buildApiServer() + "/api/" + apiVersion + "/download-template-file"
    },
    transactions: {
      getList: buildApiServer() + "/api/" + apiVersion + "/data-transactions",
      getAssociatedList:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/data-transaction/filesources/:filesource_id",
      getDetail:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/data-transactions/:transaction_id"
    },
    incentive_processing: {
      getTemplates:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/incentive-processing/templates?programId=:programId",
      downloadTemplate:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/incentive-processing/templates/:activityId",
      uploadIncentiveFile:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/incentive-processing/files?clientId=:clientId",
      processIncentiveFile:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/incentive-processing/files/:id/:mode",
      getIncentiveFiles:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/incentive-processing/files?clientId=:clientId",
      downloadIncentiveFile:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/incentive-processing/files/:id",
      downloadIncentiveReport:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/incentive-processing/files/:id/report",
    },
    extracts: {
      getExtracts:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/extracts/requests?clientId=:clientId&extractType=:extractType",
      getExtractsType:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/reference-data/extract-type",
      requestGenerateReports:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/extracts/report",
      downloadExtract:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/extracts/files/:id?subFileId=:subFileId",
      notification:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/notifications/user/:userId/unread",
    },
    roles: {
      getList: buildApiServer() + "/api/" + apiVersion + "/roles",
      getClientAdminList:
        buildApiServer() + "/api/" + apiVersion + "/client-admin/roles",
      add: buildApiServer() + "/api/" + apiVersion + "/roles",
      edit: buildApiServer() + "/api/" + apiVersion + "/roles/:id",
      detail: buildApiServer() + "/api/" + apiVersion + "/roles/:id"
    },
    permissions: {
      getList: buildApiServer() + "/api/" + apiVersion + "/permissions",
      getClientAdminList:
        buildApiServer() + "/api/" + apiVersion + "/client-admin/permissions",
      add: buildApiServer() + "/api/" + apiVersion + "/permissions",
      edit: buildApiServer() + "/api/" + apiVersion + "/permissions/:id",
      detail: buildApiServer() + "/api/" + apiVersion + "/permissions/:id"
    },
    clientsftp: {
      getList: buildApiServer() + "/api/" + apiVersion + "/clientsftp",
      add: buildApiServer() + "/api/" + apiVersion + "/clientsftp",
      edit:
        buildApiServer() + "/api/" + apiVersion + "/clientsftp/:client_sftp_id"
    },
    program_points: {
      get: buildApiServer() + "/api/" + apiVersion + "/programPoints/:id",
      set: buildApiServer() + "/api/" + apiVersion + "/programPoints/:id"
    },
    programs: {
      getList: buildApiServer() + "/api/" + apiVersion + "/programs",
      getListByClientId: buildApiServer() + "/api/" + apiVersion + "/programs-by-client/:id",
      get: buildApiServer() + "/api/" + apiVersion + "/programs/:id",
      getCurrentProgramStatus: buildApiServer() + "/api/" + apiVersion + "/program-users/:clientId/:employeeId/current-info/:subgroupId?showUserEvents=false",
      detail: buildApiServer() + "/api/" + apiVersion + "/programs/:id/detail",
      add: buildApiServer() + "/api/" + apiVersion + "/programs",
      edit: buildApiServer() + "/api/" + apiVersion + "/programs/:id",
      delete: buildApiServer() + "/api/" + apiVersion + "/programs/:id",
      updateLevels:
        buildApiServer() + "/api/" + apiVersion + "/programs/:id/update-levels",
      getByClientId:
        buildApiServer() + "/api/" + apiVersion + "/:clientId/current-program",
      assignProgramEmployer:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs/:id/assign-to-employers",
      exportTemplate:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-templates/:id/export-template",
      cloneProgram:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-templates/:id/create-program",
      getListTemplate:
        buildApiServer() + "/api/" + apiVersion + "/program-templates",
      exportCsv:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs/:programId/export/:clientId?token=:tokenId",
      updateBySubgroup:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs/update-by-subgroup",
      previewHpsf:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program/preview-hpsf-form?hpsfFormType=:formType",
      getHpsfFormTypeList:
        buildApiServer() + "/api/" + apiVersion + "/program/hpsf-form-types",
      programMilestones:
        buildApiServer() + "/api/" + apiVersion2 + "/program-milestones"
    },
    program_phases: {
      getByProgramId:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-phases?programId.equals=:programId",
      getByPhaseId:
        buildApiServer() + "/api/" + apiVersion + "/program-phase/:phaseId",
      add: buildApiServer() + "/api/" + apiVersion + "/program-phase",
      edit: buildApiServer() + "/api/" + apiVersion + "/program-phase",
      delete:
        buildApiServer() + "/api/" + apiVersion + "/program-phase/:phaseId",
      updatePhase:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-activities-update-phase"
    },
    program_activity: {
      getAvailableActivities:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/activities/:programId/avail-activities",
      getAvailableActivitiesEmployerVerified:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/custom-activities/:programId/employer-verified",
      getAllActivitiesTemplates:
        buildApiServer() + "/api/" + apiVersion + "/common/cc-activities",
      getAllActivitiesCustom:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/common/cc-activities/custom-activities/:programId",
      exportActivityCsv:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/activity-employer-verified-csv/:activityCode/:activityId",
      getProgramActivitiesFromAP:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/activities/:programId/program-activities",
      getAllProgramActivitiesFromAP:
        buildApiServer() + "/api/" + apiVersion + "/custom-activities",
      getProgramActivitiesFromProgramServ:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-activities?programId.equals=:id",
      getActivitiesByPhasesProgramServ:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-activities?programId.equals=:programId&programPhaseId.equals=:phaseId",
      getAvailableActivity:
        buildApiServer() + "/api/" + apiVersion + "/activities/:id",
      getCustomActivityTemplate:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/custom-activities-template/:id",
      getCustomActivity:
        buildApiServer() + "/api/" + apiVersion + "/custom-activities/:id",
      getCustomActivitiesByIds:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/custom-activities?ids=:listId",
      getProgramActivity:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-activities?programId.equals=:id",
      addCustomActivity:
        buildApiServer() + "/api/" + apiVersion + "/program/custom-activities",
      addProgramActivity:
        buildApiServer() + "/api/" + apiVersion + "/program-activities",
      editCustomActivity:
        buildApiServer() + "/api/" + apiVersion + "/custom-activities/:id",
      editProgramActivity:
        buildApiServer() + "/api/" + apiVersion + "/program-activities/:id",
      deleteCustomActivity:
        buildApiServer() + "/api/" + apiVersion + "/custom-activities/:id",
      deleteProgramActivity:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs/:programId/activities/:activityId",
      bulkCreateProgramActivities:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-activities/:id/bulk",
      bulkCreateCustomActivities:
        buildApiServer() + "/api/" + apiVersion + "/custom-activities/bulk",
      bulkDeleteCustomActivities:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/custom-activities/bulk-delete",
      bulkDeleteProgramActivities:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-activities/:programId/bulk-delete",
      bulkEditProgramActivitiesDate:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/custom-activities/update-date-activities",
      saveCustomActivities:
        buildApiServer() + "/api/" + apiVersion + "/save-custom-activities",
      update:
        buildApiServer() + "/api/" + apiVersion + "/program-activity/update",
      updatePhase:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-activity/update-phase",
      getLesMillsResource:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-activity/resource/les-mills/video-list?search=:searchString",
      searchProgramActivities:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-activities/search/:programId"
    },
    program_rewards: {
      getList: buildApiServer() + "/api/" + apiVersion + "/rewards",
      getListProgramRewardErrors:
        buildApiServer() + "/api/" + apiVersion + "/reward-error-logs",
      getListProgramRewardHistory:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-reward-history/:programId",
      getListEmployeeRewardHistory:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/employee-reward-history/:employeeId",
      getListRewardAccessToken:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-program-reward-settings",
      getRewardAccessTokenDetail:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-program-reward-settings/:id",
      // addRewardAccessToken: buildApiServer() + '/api/' + apiVersion + '/client-program-reward-settings',
      // editRewardAccessToken: buildApiServer() + '/api/' + apiVersion + '/client-program-reward-settings',
      createTremendousTeam:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-program-reward-settings/create-tremendous-team",
      generateAccessToken:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-program-reward-settings/generate-access-token",
      deleteRewardAccessToken:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-program-reward-settings/:id",
      getListCampaigns:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-program-reward-settings/campaigns",
      updateMilestoneRewards:
        buildApiServer() +
        "/api/" +
        apiVersion2 +
        "/program-milestone-rewards",
    },
    program_tango: {
      getTangoCatalogs:
        buildApiServer() + "/api/" + apiVersion + "/tango-card/catalogs"
    },
    program_level_rewards: {
      addRewardsToLevel:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-level-rewards/:id/update-rewards"
    },
    program_level_activities: {
      addActivitiesToLevel:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-levels/:id/update-activities",
      addActivityToLevel:
        buildApiServer() + "/api/" + apiVersion + "/program-levels/add-activity"
    },
    program_categories: {
      getList: buildApiServer() + "/api/" + apiVersion + "/programs-categories",
      editList:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs-categories-points/:id/add-categories",
      saveList:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs-categories-points/:id/update-categories",
      add: buildApiServer() + "/api/" + apiVersion + "/program-category-points",
      edit:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-category-points/:id",
      addCategories:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs-categories-points/:id/add-categories",
      addSubCategories:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs-categories-points/:id/add-sub-categories"
    },
    program_sub_categories: {
      getList:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs-categories/sub-categories/?limit=0&categoryCode.equals=",
      add:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-sub-category-points",
      edit:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-sub-category-points/:id",
      editList:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/programs-categories-points/:id/add-sub-categories"
    },
    program_logo: {
      getPresignedUrl:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/uploads/presigned?resource=program&filename=:id"
    },
    email_template: {
      getList: buildApiServer() + "/api/" + apiVersion + "/email-template",
      add: buildApiServer() + "/api/" + apiVersion + "/email-template",
      edit: buildApiServer() + "/api/" + apiVersion + "/email-template/:id",
      detail: buildApiServer() + "/api/" + apiVersion + "/email-template/:id"
    },
    sisense: {
      reports: buildApiServer() + "/api/" + apiVersion + "/sisense"
    },
    subgroups: {
      getSubgroups: buildApiServer() + "/api/" + apiVersion + "/subgroups"
    },
    termConditions: {
      getByClient:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/term-and-conditions/get-by-client/:clientId",
      updateTermCondition:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/term-and-conditions/update-list",
      deleteTermCondition:
        buildApiServer() + "/api/" + apiVersion + "/term-and-conditions/:id",
      addTermCondition:
        buildApiServer() + "/api/" + apiVersion + "/term-and-conditions"
    },
    consent: {
      getByClient:
        buildApiServer() + "/api/" + apiVersion + "/consent/:clientId",
      updateConsent: buildApiServer() + "/api/" + apiVersion + "/consent",
      deleteConsent: buildApiServer() + "/api/" + apiVersion + "/consent/:id",
      addConsent: buildApiServer() + "/api/" + apiVersion + "/consent"
    },
    clientBrand: {
      getByClient:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-brand-settings/get-by-client/:clientId",
      create:
        buildApiServer() + "/api/" + apiVersion + "/client-brand-settings",
      update:
        buildApiServer() + "/api/" + apiVersion + "/client-brand-settings/:id"
    },
    levelPaths: {
      getAllTemplate:
        buildApiServer() + "/api/" + apiVersion + "/common/cc-activities/paths",
      getAllRASTemplate:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/common/cc-activities/ras-paths",
      getAll: buildApiServer() + "/api/" + apiVersion + "/program-level-paths",
      update:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-level-paths/:programLevelId/update-paths",
      delete:
        buildApiServer() + "/api/" + apiVersion + "/program-level-paths/:id",
      addPathToLevel:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-level-paths/add-path"
    },
    programBiometric: {
      getAll:
        buildApiServer() + "/api/" + apiVersion + "/program-biometric-data"
    },
    programHealtyRange: {
      getAll:
        buildApiServer() + "/api/" + apiVersion + "/program-healthy-ranges",
      add: buildApiServer() + "/api/" + apiVersion + "/program-healthy-ranges",
      update:
        buildApiServer() + "/api/" + apiVersion + "/program-healthy-ranges/:id",
      init:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-healthy-ranges/save-list"
    },
    programRequirementItems: {
      getAll:
        buildApiServer() + "/api/" + apiVersion + "/program-requirement-items",
      add:
        buildApiServer() + "/api/" + apiVersion + "/program-requirement-items",
      delete:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-requirement-items/:id",
      update:
        buildApiServer() + "/api/" + apiVersion + "/program-requirement-items"
    },
    programCohort: {
      getCohorts:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-cohorts-extension/:programId",
      addCohort:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-cohorts-extension/save-list",
      removeCohort:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-cohorts-extension/:id",
      getCollections:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-collections/:programId",
      removeCollection:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-cohorts-extension/remove-collection/:id",
      getCollectionListById:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-cohorts-extension/collection-contents"
    },
    columnMapping: {
      getColumnMappings:
        buildApiServer() + "/api/" + apiVersion + "/columnmapping",
      getById: buildApiServer() + "/api/" + apiVersion + "/columnmapping/:id",
      setColumnMapping:
        buildApiServer() + "/api/" + apiVersion + "/columnmapping/:id",
      addColumnMapping:
        buildApiServer() + "/api/" + apiVersion + "/columnmapping",
      getDefaultFieldsByDataType:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/columnmapping/get-default-list"
    },
    programCollection: {
      getCollectionByProgramId:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-collections-extension/:programId",
      saveCollection:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-collections-extension/save-list",
      removeCollectionList:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-collections-extension/remove",
      checkDeleteItem:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/program-collections-extension/check-delete-item"
    },
    apiVersion: {
      getCurrent: buildApiServer() + "/api/" + apiVersion + "/version"
    },
    clientAdmin: {
      getListRequest:
        buildApiServer() + "/api/" + apiVersion + "/client-admin/requests",
      getRequest:
        buildApiServer() + "/api/" + apiVersion + "/client-admin/requests/:id",
      updateRequest:
        buildApiServer() + "/api/" + apiVersion + "/client-admin/requests/:id",
      postListRequest:
        buildApiServer() + "/api/" + apiVersion + "/client-admin/requests",
      postApproveRequest:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-admin/requests/:requestId/confirm",
      getListRequestByClientId:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-admin/requests/client/:clientId",
      filterListChangeLog:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-admin/requests?searchJoin=and",
      filterListChangeLogByClientId:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-admin/requests/client/:clientId?searchJoin=and",
      getListClientPanel:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-admin/users/client/:clientId",
      filterAdminPanel:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-admin/users?search=filterStr&searchJoin=and",
      filterClientPanel:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-admin/users/client/:clientId?search=filterStr&searchJoin=and",
      getUserDetails:
        buildApiServer() + "/api/" + apiVersion + "/client-admin/users/:userId",
      resendInvitation:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/client-admin/users/resend-invitation/:userId"
    },
    security: {
      getBlockedDomains:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/blocked-domains?searchJoin=and&search=filterStr",
      postAddBlockedDomain:
        buildApiServer() + "/api/" + apiVersion + "/blocked-domains",
      deleteBlockedDomain:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/blocked-domains/:blockedDomainId",
      getUsePolicy:
        buildApiServer() +
        "/api/" +
        apiVersion +
        "/policy?searchJoin=and&search=filterStr",
      getActiveUsePolicy:
        buildApiServer() + "/api/" + apiVersion + "/policy/active",
      postUsePolicy: buildApiServer() + "/api/" + apiVersion + "/policy",
      deleteUsePolicy:
        buildApiServer() + "/api/" + apiVersion + "/policy/:usePolicyId"
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/api-call.js